import { Injectable, OnDestroy } from '@angular/core';
import { environment } from '@efsEnvironments/environment';
import { EfsApiService } from '@EfsServices/efs-api.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GenericPopupComponent } from '@EfsReusable/generic-popup/generic-popup.component';
import { SessionService } from '@EfsServices/session.service';
import { LoggingService } from '@EfsServices/logging.service';

// import { EfsApiService } from '@EfsServices/efs-api.service';
// import { SessionService } from '@EfsServices/session.service';

import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class SessionTimerService {

  timeout = null;
  finalCountDown;
  popupDialogRef;

  constructor(
    private efsApiService: EfsApiService,
    public dialog: MatDialog,
    private sessionService: SessionService,
    private cookieService: CookieService,
    private loggingService: LoggingService,
  ) { }

  stopTimers() { // DERPECATED?
    // console.log('WAS THE SESSION TIMER DESTROYED?');
    // clearTimeout(this.timeout);
    // clearTimeout(this.finalCountDown);
  }

  checkSessionStatus() {
    // return;
    // console.log('MOUSE MOVED!!!');
    if (this.timeout != null) {
      // console.log('timer is active, do nothing');
      return;
    } else {
      console.log('timer is inactive and mouse moved, set timer');

      this.timeout = setTimeout(() => {
        console.log('Time is up');
        // this.expireUser();
        // this.popupWarning(true, 'Session expiring', 'Session will expire in 1 minute, would you like to continue?');
        this.serviceIsActiveUser();
        this.timeout = null;
      }, 45000); // 840000 is 14 minutes // 480000 is 8 minutes //300000 5 minutes // 60000 1 minutes
    }
    // console.log(this.timeout);
    // clearTimeout(this.timeout);
  }

  /**
   * Begins final 3 minute interruptable timer to expire user. If user clicks yes, the timer is refreshed, call to
   * isActiveUser refreshes session and user is allowed to continue. If user clicks no, user is immediately dumped to
   * customer center. If user waits out final 3 minutes, user is dumped to Customer Center
   */
  expireUser() {
    this.finalCountDown = setTimeout(() => {
      console.log('USER EXPIRED, USER WILL BE SENT TO CUSTOMER CENTER');
      if (environment.envName !== 'dev') {
        // send user back to CC
        sessionStorage.clear();
        this.loggingService.logInfo('User Was kicked out by expireUser in sessionTimerService');
        document.location.href = this.efsApiService.redirectUrl;
      } else {
        this.dialog.closeAll();
        this.checkSessionStatus();
      }
    }, 60000); // 60000 is 1 minutes
  }

  popupWarning(questionType, title, message) {
    this.popupDialogRef = this.dialog.open(GenericPopupComponent, {
      width: '450px',
      height: '275px',
      panelClass: 'popup-borders',
      disableClose: true,
      data: {
        questionType,
        title,
        message
      }
    }).afterClosed().subscribe(result => {
      // a button has been pressed, make sure the final Countdown is shut down dodododoo
      clearTimeout(this.finalCountDown);
      if (result) { // user clicked yes
        console.log('clicked yes');
        this.serviceIsActiveUser();
      } else if (!result) { // user clicked no
        console.log('clicked no');
        if (environment.envName !== 'dev') {
          sessionStorage.clear();
          this.loggingService.logInfo('User Was kicked out by popupWarning in sessionTimerService');
          document.location.href = this.efsApiService.redirectUrl;
        }
      }
    });
    // return true;
  }

  serviceIsActiveUser() {
    this.sessionService.isActiveUser().subscribe((data: any) => {
      console.log(JSON.stringify(data));
      this.cookieService.delete('token', '/planTemplate');
      console.log('is active user' + data);
      // if (environment.envName === 'dev') {
      //   document.cookie = 'token=' + data + '; path=/';
      // }
      document.cookie = 'token=' + data + '; path=/';
      // this.cookieService.set('token', data, 1, '/');
      this.efsApiService.setHttpOptions();
      this.sessionService.setHttpOptions();
      // this.router.navigate(['setup']); // not used in this component
      // after calling this method, if user is active, restart the countdown
      // this.checkSessionStatus();
      this.timeout = null;
    }, error => {
      // any error in this service should result in the user being kicked
      // this.apiErrorHandlingService.errorStatusHandler(error);
      // Active User Service failed, kick user from application
      if (environment.envName !== 'dev') {
        sessionStorage.clear();
        this.loggingService.logInfo('User Was kicked out by serviceIsActiveUser in sessionTimerService');
        document.location.href = this.efsApiService.redirectUrl;
      } else if (environment.envName === 'dev') {
        // alert('Session is expired ' + JSON.stringify(error));
        console.log('Session is expired ' + JSON.stringify(error));
      }
    });
  }

}
